import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed, onMounted, ref, watch } from 'vue';
import ExpandCollapse from '@/ui/shared/ExpandCollapse.vue';
import CollapsibleContent from '@/ui/shared/CollapsibleContent.vue';
import CountryService from '@/services/country.service';

import DeliveryCountrySelectItemViewObject = Vertica.LouisPoulsen.Application.Content.Pages.Basket.Business.DeliveryCountrySelectItemViewObject;
import { useValidator } from '@/core/app.service';
import impersonationService from '@/services/impersonation.service';
import addressValidationService from '@/services/address-validation.service';
import ImpersonateCustomerRequest = Vertica.LouisPoulsen.Application.Authentication.Api.Requests.ImpersonateCustomerRequest;
import { useImpersonation } from '@/store/impersonation.composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImpersonateModal',
  props: {
    openState: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { openState: boolean }


function fetchQuoteBasket() {
    store.dispatch('quotebasket/fetchQuoteBasket');
}



const textColor = computed<OpacityFunction>(() => store.getters['app/textColor']);

const customerNumber = ref<string>('');

const step = ref<number>(1);
const form = ref<ImpersonateCustomerRequest>(null);
const allowEdit = ref<boolean>(false);

const editCollapsible = ref<CollapsibleContent>(null);

const addressValidationRequestId = ref<string>(null);
const addressValidationRequest = computed<Vertica.LouisPoulsen.Application.AddressValidation.Api.Requests.AddressValidationWebRequest>(() => {
    return {
        previousResponseId: addressValidationRequestId.value,
        address: {
            city: form.value.city,
            company: '',
            countryCode: form.value.countryCode,
            district: '',
            email: '',
            name: '',
            phoneNo: '',
            postalCode: form.value.postalCode,
            regionCode: form.value.regionCode,
            street: form.value.street,
            subUnit: form.value.subUnit
        }
    };
});

watch(() => props.openState, async() => { await loadCustomerAutomatically(); });

onMounted(async() => { await loadCustomerAutomatically(); });

async function loadCustomerAutomatically() {
    if (impersonation.value.canImpersonateDummyCustomersOnly) {
        await useDummyCustomer();
    }
}

async function useDummyCustomer() {
    customerNumber.value = impersonation.value.defaultDummyCustomerId;
    await requestImpersonation();
}

async function requestImpersonation() {
    if (step.value === 1) {
        const response = await impersonationService.validateCustomer({
            customerId: customerNumber.value
        });
        if (response && response.isValid) {
            countries.value = await impersonationService.initialize();
            allowEdit.value = response.isDummy;

            if (response.address) {
                form.value = {
                    customerId: customerNumber.value,
                    city: response.address.city,
                    company: response.address.company,
                    countryCode: response.address.countryCode,
                    district: response.address.district,
                    email: response.address.email,
                    name: response.address.name,
                    phoneNo: response.address.phoneNo,
                    postalCode: response.address.postalCode,
                    regionCode: response.address.regionCode,
                    street: response.address.street,
                    subUnit: response.address.subUnit
                };
            } else {
                form.value = {
                    customerId: customerNumber.value,
                    city: '',
                    company: '',
                    countryCode: '',
                    district: '',
                    email: '',
                    name: '',
                    phoneNo: '',
                    postalCode: '',
                    regionCode: '',
                    street: '',
                    subUnit: ''
                };
            }
            step.value++;
        }
    }
}

const countries = ref<DeliveryCountrySelectItemViewObject[]>();

const selectedCountry = computed<DeliveryCountrySelectItemViewObject>({
    get() {
        return hasAddress.value ? countries.value.find(c => c.countryCode === form.value.countryCode) : null;
    },
    set(newValue: DeliveryCountrySelectItemViewObject) {
        form.value.countryCode = newValue.countryCode;
    }
});

const states = ref<StateViewObject[]>();

const selectedState = computed<StateViewObject>({
    get() {
        return hasAddress.value && states.value ? states.value.find(c => c.code === form.value.regionCode) : null;
    },
    set(newValue: StateViewObject) {
        form.value.regionCode = newValue.code;
    }
});

const hasAddress = computed<boolean>(() => form.value !== null);

const $validator = useValidator();

const { impersonation, noImpersonation, finishImpersonation } = useImpersonation();

async function setAddressData() {
    const isValid = await $validator.validateAll();
    await onAddressChanged();
    if (!isValid) {
        const errorFields = $validator.errors.items.map(x => x.field);
        const fieldsNotInCollapsible = ['customerNumber', 'name', 'city', 'department'];
        if (errorFields.some(x => fieldsNotInCollapsible.indexOf(x) === -1)) {
            editCollapsible.value.open();
        }
    } else {
        finishImpersonation(form.value).then(() => {
            emit('close');
            step.value = 1;
            customerNumber.value = '';
            form.value = null;
            fetchQuoteBasket();
        });
    }
}

async function onAddressChanged() {
    const responseId = await addressValidationService.validateAddress(addressValidationRequest.value);
    addressValidationRequestId.value = responseId;
}

watch(selectedCountry, onSelectedCountryChanged);
function onSelectedCountryChanged(country: DeliveryCountrySelectItemViewObject) {
    if (country && country.hasStates) {
        CountryService.getCountryStates(country.countryCode).then(data => {
            states.value = data;
        });
    } else {
        states.value = [];
    }
}

function close() {
    noImpersonation();
    emit('close');
}

watch(() => customerNumber.value, () => { step.value = 1; });

return { __sfc: true,props, fetchQuoteBasket, emit, textColor, customerNumber, step, form, allowEdit, editCollapsible, addressValidationRequestId, addressValidationRequest, loadCustomerAutomatically, useDummyCustomer, requestImpersonation, countries, selectedCountry, states, selectedState, hasAddress, $validator, impersonation, noImpersonation, finishImpersonation, setAddressData, onAddressChanged, onSelectedCountryChanged, close, ExpandCollapse, CollapsibleContent }
}

})